import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, MenuItem, TextField, Switch, FormControlLabel, IconButton, Chip } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useAppData } from '../../../../../../context/AppDataContext';
import taskServices from '../../taskServices';




const TaskStatusBadge = ({ value, callBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [inputStatus, setInputStatus] = useState(value);
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");

    const {masters,getMasterLabel} = useAppData();


    const handleUpdate = () => {
        if (callBack) {
            callBack({
                taskStatus: inputStatus,
                notify: notify,
                remark: remark
            });
        }
        setDialogStatus(false);
        setRemark(""); // Reset remark for next use
    };

    const chipProps = {
        label: getMasterLabel('task-status', value),
        className: taskServices.statusColorClass[value] || "bg-light text-dark",
        sx: { 
            fontWeight: 'bold',
            border: 'none',
            '& .MuiChip-label': { px: 2 }
        }
    };

    // Add interactive props only if callBack is provided
    if (callBack) {
        chipProps.onClick = () => setDialogStatus(true);
        chipProps.onDelete = () => setDialogStatus(true);
        chipProps.deleteIcon = <Edit style={{ color: 'inherit', fontSize: '14px' }} />;
    }

    return (
        <>
            {/* Visual Chip to display current status */}
            <Chip {...chipProps} />
            {callBack && 
            <Dialog
                open={dialogStatus}
                onClose={() => setDialogStatus(false)}
                fullWidth={true}
                maxWidth="xs"
            >
                <div className='p-3 fw-bold border-bottom'>Update Task Status</div>
                <DialogContent>
                    <div className='row mt-2'>
                        <div className='col-md-12'>
                            {/* Status Selection */}
                            <TextField
                                select
                                fullWidth
                                label="Select Status"
                                value={inputStatus}
                                onChange={(e) => setInputStatus(e.target.value)}
                                margin="normal"
                            >
                                {masters['task-status'].map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>

                            {/* Remark Textarea */}
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Remark/Reason for change"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                margin="normal"
                                placeholder="Why is this status changing?"
                            />

                            {/* Notification Toggle */}
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={notify}
                                        onChange={(e) => setNotify(e.target.checked)}
                                    />
                                }
                                label="Notify assigned users"
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="p-3">
                    <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                    <button className='btn btn-primary' onClick={handleUpdate}>Update Status</button>
                </DialogActions>
            </Dialog>
            }
        </>
    );
};

export default TaskStatusBadge;